<template>
  <div id="modalDiscard" class="modal fade modal-md show" tabindex="-1" aria-labelledby="exampleModalLabel"
    aria-modal="true" role="dialog" style="display: block">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content !rounded-[20px]">
        <div class="modal-body p-4 pb-5">
          <div class="flex flex-col gap-4 w-full">
            <div class="flex items-center justify-between">
              <div class="flex items-center gap-2">
                <span class="w-2 h-2 rounded-full bg-[#FE5000]"></span>
                <span class="w-10 h-2 rounded-full bg-[#FE5000]"></span>
                <h2 class="m-0 font-lato font-[700] text-[20px] text-[#092E87]">TradeCall Fee Disclaimer</h2>
              </div>
              <button class="w-[40px] h-[40px] p-2 bg-[#fff]" @click="closeModal" type="button" data-bs-dismiss="modal"
                aria-label="Close">
                <img src="@/assets/images/modal-cross-icon.png">
              </button>
            </div>
            <p class="m-0 font-lato text-[16px] leading-6 text-[#333333]">
              This claim request includes a TradeCall fee for
              {{ apptDetail.depp_schedule.tradecall_fee_text ?? $0 }} , which
              is the sole responsibility of the Technician working on this
              claim request, to collect from the consumer. Should you fail to
              collect the TradeCall from the Consumer, fyxify™ will not be
              responsible for reimbursing the same.
            </p>
            <ul class="p-0 m-0 flex flex-col gap-2 my-3">
              <li>
                <label
                  class="m-0 flex items-center gap-2 p-2 rounded-[5px] cursor-pointer bg-opacity-50 border border-[#EFEFEF] bg-[#EFEFEF]">
                  <!-- Native radio hidden -->
                  <input v-model="check" value="0" type="radio" class="hidden peer" />

                  <!-- Custom radio -->
                  <span class="w-[16px] h-[16px] border-[1px] rounded-full flex items-center justify-center
                  border-gray-400 bg-white
                  peer-checked:border-[#FE5000]">
                    <!-- Inner dot -->
                    <span v-if="check === '0'" class="w-[8px] h-[8px] bg-[#FE5000] rounded-full"></span>
                  </span>

                  <!-- Label text -->
                  <span class="font-lato text-[14px] text-[#092E87]">
                    I accept that I will collect TradeCall fee from consumer.
                  </span>
                </label>
              </li>
              <li>
                <label
                  class="m-0 flex items-center gap-2 p-2 rounded-[5px] cursor-pointer bg-opacity-50 border border-[#EFEFEF] bg-[#EFEFEF]">
                  <input v-model="check" value="1" type="radio" class="hidden peer">

                  <!-- Custom radio -->
                  <span class="w-[16px] h-[16px] border-[1px] rounded-full flex items-center justify-center
                  border-gray-400 bg-white
                  peer-checked:border-[#FE5000]">
                    <!-- Inner dot -->
                    <span v-if="check === '1'" class="w-[8px] h-[8px] bg-[#FE5000] rounded-full"></span>
                  </span>
                  <span class="font-lato text-[14px] text-[#092E87]">Waive TradeCall fee for this job.</span>
                </label>
              </li>
            </ul>
            <div class="flex justify-center items-center gap-3">
              <span
                class="hidden laptop:block border-1 py-2 px-5 rounded-full cursor-pointer transition duration-300 text-[#FD5000] border-[#FD5000] hover:bg-[#FD5000] hover:text-[#fff]"
                @click="closeModal">Dismiss</span>
              <span
                class="border-1 py-2 px-5 rounded-full cursor-pointer transition duration-300 mobile:text-white laptop:text-[#092E87] border-[#092E87] mobile:bg-[#092E87] laptop:bg-white laptop:hover:bg-[#092E87] laptop:hover:text-[#fff]"
                @click="confirm">Submit</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { useToast } from "vue-toastification";
import { ref } from "vue";
import { enableScroll } from "../../helpers/scrollHelper";
const toast = useToast();

export default {
  components: {},

  data() {
    return {
      check: "0",
    };
  },
  computed: {
    ...mapGetters(["quoteDetail", "apptDetail"]),
  },

  watch: {},

  mounted() { },

  methods: {
    ...mapActions(["setCommponent"]),

    editQuoteClicked() {
      this.setCommponent("QuoteItems");
    },

    closeModal() {
      document.documentElement.style.overflow = '';
      enableScroll()
      this.check = "0";
      this.$emit("event", "close");
    },

    confirm() {
      document.documentElement.style.overflow = '';
      enableScroll()
      this.$emit("event", "confirm", this.check);

      // this.$emit("event", "confirm");
      // if (this.check) {
      //   this.check = false;
      //   this.$emit("event", "confirm");
      // } else {
      //   toast.error("You must agree to above condition to continue.");
      // }
    },
  },
};
</script>
